import { render, staticRenderFns } from "./ContentTypeCalendar.vue?vue&type=template&id=679f8ee5"
import script from "./ContentTypeCalendar.vue?vue&type=script&lang=js"
export * from "./ContentTypeCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports